<div class="page page--primary rewards" [class.is-blurred]="showSupportForm || gamePopupInfo.show">
    <app-logo-bg></app-logo-bg>

    <div class="page__inner">

        <div class="page__row rewards__head">
            <h2 *ngIf="showPointName()" class="page__point">{{getPointName()}}</h2>
            <div style="margin-left: auto">
                <h1 class="page__title">REWARDS</h1>
                <h2 *ngIf="isPartnerTypeSingleBalance()" class="page__balance">Available Balance {{availableBalance | currency : 'USD' : 'symbol'}}</h2>
            </div>

        </div>

        <div class="page__body">
            <div class="rewards__ad rewards__ad--no-mt">
                <div class="ad-simple">
                    <h2 class="ad-simple__title gl-title">LIMITED SWEEPS OFFER</h2>
                    <p class="ad-simple__text gl-subtitle">For a limited time, we offer dollar-per-dollar sweepstakes entries on all purchases.</p>
                </div>
            </div>

            <div *ngIf="adsGame != ''" class="rewards__ad rewards__ad--no-mt">
                <div class="ad-simple">
<!--                    <p class="ad-simple__text gl-title ad-simple__highlight"><a href="https://{{adsSenetpro}}" target="_blank">New platform <span>{{adsGame}}</span> is now available at <span>{{adsSenetpro}}</span>!</a></p>-->
                  <p class="ad-simple__text gl-title ad-simple__highlight"><a href="https://{{adsSenetpro}}" target="_blank">Instant withdrawals and more platforms on <span>{{adsSenetpro}}</span>!</a></p>

                </div>
            </div>

            <div class="games-selection" *ngIf="providers.length > 1">
                <form [formGroup]="providersForm" class="form-simple form-simple--shrink form-simple--primary">
                    <div class="form-simple__item">
                        <mat-form-field>
                            <!--                        <mat-label>GET</mat-label>-->
                            <mat-select #providersSelect
                                        formControlName="providers"
                                        (valueChange)="onProviderChange($event)"
                                        [(value)]="selectedProvider" panelClass="my-select-panel-border-yellow">
                                <mat-select-trigger>
                                    {{providersSelect?.value?.name}}
                                </mat-select-trigger>
                                <mat-option *ngFor="let provider of providers" [value]="provider">
                                    {{provider.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </form>
            </div>

            <div *ngIf="riverView" class="rewards__info">
                <div *ngIf="userPin" class="rewards__pin">
                    <div id="rewards_code" class="rewards__code">{{userPin}}</div>
                </div>
            </div>


            <div *ngIf="goldenDragonView" class="rewards__info rewards__info--mb">
                <div class="rewards__row">
                    <div class="rewards__col">Mobile ID:
                    </div>
                    <div class="rewards__col">
                        {{gd_mobile_id}}
                    </div>
                </div>

                <div class="rewards__row">
                    <div class="rewards__col">
                        Password:
                    </div>
                    <div class="rewards__col">
                        {{gd_password}}
                    </div>
                </div>
            </div>

            <div class="game" *ngIf="activeProvider">
                <div class="game__item">
                    <img [src]="activeProvider.image_link"
                         alt=""
                         class="game__img"
                         (click)="isApp ? onSweepsKiosk() : onSweeps(true)">

                    <div class="game__content">
                        <div class="game__description" [innerHTML]="activeProvider.description"></div>
                        <button (click)="isApp ? onSweepsKiosk() : onSweeps(true)" class="game__btn">PLAY</button>
                        <button (click)="goToSupport()" class="game__btn">Support</button>
                    </div>
                </div>

                <div class="rewards__footer">
                    <div class="rewards__btns">
                        <a [routerLink]="getLinkToNFT()" class="navigation__button navigation__button--rounded is-notouched">
                            <span class="navigation__button-text">MINT <br>NFT</span>
                            <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M85 43C85 19.804 66.196 1 43 1M1 43C1 66.196 19.804 85 43 85C54.6712 85 65.2305 80.2394 72.8421 72.5542" stroke-width="2"/>
                            </svg>
                        </a>
                        <button (click)="getLinkToFunds()" class="navigation__button navigation__button--rounded is-notouched">
                            <span class="navigation__button-text">ADD <br>FUNDS</span>
                            <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M85 43C85 19.804 66.196 1 43 1M1 43C1 66.196 19.804 85 43 85C54.6712 85 65.2305 80.2394 72.8421 72.5542" stroke-width="2"/>
                            </svg>
                        </button>
                        <a *ngIf="isPointPlayersEarnIncome()" [routerLink]="getLinkToEarnIncome()" class="navigation__button navigation__button--rounded is-notouched">
                            <span class="navigation__button-text">EARN <br>INCOME</span>
                            <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M85 43C85 19.804 66.196 1 43 1M1 43C1 66.196 19.804 85 43 85C54.6712 85 65.2305 80.2394 72.8421 72.5542" stroke-width="2"/>
                            </svg>
                        </a>
                    </div>
                </div>

<!--                <div class="rewards__ad">-->
<!--                    <div class="ad-simple">-->
<!--                        <h2 class="ad-simple__title">ACE REVEAL AVAILABLE NOW!</h2>-->
<!--                        <p class="ad-simple__text">Go to AceReveal.com and use Promo Code: NFT</p>-->

<!--                        <div class="ad-simple__row">-->
<!--                            <div class="ad-simple__col"></div>-->
<!--                            <a [href]="advertiseLink" target="_blank" class="ad-simple__btn">PLAY ACE REVEAL</a>-->
<!--                        </div>-->
<!--                        <a [href]="advertiseLink" target="_blank">-->
<!--                            <img class="ad-simple__img" src="../../../assets/images/advertise/acereveal.png" alt="AceReveal">-->

<!--                        </a>-->

<!--&lt;!&ndash;                        <h2 class="ad-simple__title">COMING COON</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                        <p class="ad-simple__text">We are excited to share with you that soon you will be able to mint your own NFTs’ by simply uploading any image of your choice! We are also adding for you the unique ability to create your own Ethereum Wallet at no cost to you with a single click.</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        <p class="ad-simple__text">According to a new estimate from blockchain analytics firm Chainalysis Inc., nearly $41 billion worth of cryptocurrency was sent to two types of Ethereum smart contracts associated with NFT marketplaces and collections from the beginning of 2021 through mid-December.</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        <p class="ad-simple__text">We are thrilled for you to be part of that exploding market!</p>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</div>

<div class="senet-iframe" *ngIf="senetURL">
    <iframe [src]="senetURL" (load)="onSenetFrameLoaded($event)" frameborder="0" class="senet-iframe__frame"></iframe>
</div>

<app-popup-rewards-game-form [popupInfo]="gamePopupInfo"
                             (updateBalance)="onUpdateBalance()"
                             (onGameSweep)="onGameSweep()"
                             (close)="onCloseGamePopup()"></app-popup-rewards-game-form>
